// Main equipment classes
export { Nvr, Camera, Base } from './src/equipment';
export type { NvrConfig, BaseConfig } from './src/equipment';

// Utility functions
export { formatDate, generateUUID, sleep, isBrowser, ErrorHandler, XmlHandler } from './src/utils';

// Types and interfaces
export type * from './src/types';

// Error classes
export { 
  HikvisionError, 
  ConnectionError, 
  AuthenticationError, 
  ValidationError, 
  ApiError, 
  TimeoutError, 
  DeviceNotFoundError 
} from './src/errors/HikvisionError';

// Interfaces for dependency injection
export type { Logger, HttpClient, ConfigValidator } from './src/interfaces';
export { ConsoleLogger, NoOpLogger, AxiosHttpClient, DefaultConfigValidator } from './src/interfaces';

// Legacy default export for backward compatibility
import { Nvr } from './src/equipment/Nvr';
import { Camera } from './src/equipment/Camera';
import { SuperRender } from './src/utils/SuperRender';

export default {
  Nvr,
  Camera,
  SuperRender
};
